import { Canvas } from "@craftjs/core";
import { Shredder } from "lucide-react";

import { define } from "@/components/builder/utils";

import { OptoutFormBlock, OptoutFeedbackBlock, ConditionBlock, ConditionCaseBlock } from "..";
import BasePreview from "../base";

function OptoutPreview() {
  return <BasePreview>
    <div>
      <Canvas
        is={ConditionBlock}
        id="optout"
        properties={{ condition: 'optoutTrue', show: 'form' }}
        custom={{ state: { label: 'Page' } }}>
        <Canvas
          is={ConditionCaseBlock}
          custom={{ state: { name: 'Feedback', type: 'feedback' } }}>
          <Canvas
            is={OptoutFeedbackBlock} />
        </Canvas>
        <Canvas
          is={ConditionCaseBlock}
          custom={{ state: { name: 'Form', type: 'form' } }}>
          <Canvas
            is={OptoutFormBlock} />
        </Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

function OptoutHTML({ children }) {
  return <>
    {`{{#optout}}`}
    {children}
    {`{{/optout}}`}
  </>
}

export default define('optout', OptoutPreview, OptoutHTML)
  .canvas()
  .palete(<Shredder size={20} />, 'Optout', 'Embedded')
  .build()
